// virtual:channelizer-template/chip
var CleverpushScript = () => import("@renderer/common/cleverpush-script").then((module) => module.CleverpushScript);
var Header = () => import("../../Header-XI2DTKF4.jsx").then((module) => module.default);
var PrivacyLink = () => import("../../PrivacyLink-TY6C7UTY.jsx").then((module) => module.PrivacyLink);
var UtiqManageLink = () => import("../../UtiqManageLink-QXIRZAC3.jsx").then((module) => module.default);
export {
  CleverpushScript,
  Header,
  PrivacyLink,
  UtiqManageLink
};
